import { Field, useFormikContext } from 'formik';
import { getProductName } from 'legoland-sdk';
import { ProductLogo } from "../products/components/ProductLogo";
import styled from 'styled-components';
import { Box, Heading, Toggle, tombac } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ProductNotificationSettings = _ref => {
  let {
    productId
  } = _ref;
  const {
    values
  } = useFormikContext();
  const notifications = values[productId];
  return /*#__PURE__*/_jsxs(Container, {
    "data-sentry-element": "Container",
    "data-sentry-component": "ProductNotificationSettings",
    "data-sentry-source-file": "ProductNotificationSettings.tsx",
    children: [/*#__PURE__*/_jsxs(Box, {
      $alignItems: "center",
      $display: "flex",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "ProductNotificationSettings.tsx",
      "data-sentry-element": "Box",
      children: [/*#__PURE__*/_jsx(ProductLogo, {
        productId: productId,
        "data-sentry-element": "ProductLogo",
        "data-sentry-source-file": "ProductNotificationSettings.tsx",
        "data-sentry-element": "ProductLogo"
      }), /*#__PURE__*/_jsx(Heading, {
        $ml: "2sp",
        as: "h3",
        level: 5,
        "data-sentry-element": "Heading",
        "data-sentry-source-file": "ProductNotificationSettings.tsx",
        "data-sentry-element": "Heading",
        children: getProductName(productId)
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      $display: "flex",
      $flexDirection: "column",
      $mt: "1sp",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "ProductNotificationSettings.tsx",
      "data-sentry-element": "Box",
      children: [typeof notifications.application === 'boolean' && /*#__PURE__*/_jsxs(ToggleLabel, {
        children: [getApplicationToggleLabel(productId), ' ', /*#__PURE__*/_jsx(Field, {
          $ml: "auto",
          as: Toggle,
          checked: notifications.application,
          label: false,
          name: `${productId}.application`,
          size: "xs"
        })]
      }), typeof notifications.releaseNotes === 'boolean' && /*#__PURE__*/_jsxs(ToggleLabel, {
        children: ["Release notes", ' ', /*#__PURE__*/_jsx(Field, {
          $ml: "auto",
          as: Toggle,
          checked: notifications.releaseNotes,
          label: false,
          name: `${productId}.releaseNotes`,
          size: "xs"
        })]
      })]
    })]
  });
};
function getApplicationToggleLabel(productId) {
  switch (productId) {
    case 'od':
    case 'ts':
      return 'Change in status of reports';
    case 'ja':
      return 'Change in status of junctions';
    default:
      return 'Application notifications';
  }
}
const Container = styled.div.withConfig({
  displayName: "ProductNotificationSettings__Container"
})(["&:not(:first-child){border-top:", ";padding-top:", ";}"], tombac.parse('1u solid --neutral-400'), tombac.space(4));
const ToggleLabel = styled.label.withConfig({
  displayName: "ProductNotificationSettings__ToggleLabel"
})(["align-items:center;display:flex;margin-top:", ";", ""], tombac.space(1), tombac.text());